"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeysRdfJoin = exports.KeysExtractLinksTree = exports.KeysRdfResolveHypermediaLinks = void 0;
const core_1 = require("@comunica/core");
/**
 * When adding entries to this file, also add a shortcut for them in the contextKeyShortcuts TSDoc comment in
 * ActorIniQueryBase in @comunica/actor-init-query if it makes sense to use this entry externally.
 * Also, add this shortcut to IQueryContextCommon in @comunica/types.
 */
exports.KeysRdfResolveHypermediaLinks = {
    /**
     * Context entry for indicating the type of source annotation.
     */
    annotateSources: new core_1.ActionContextKey('@comunica/bus-rdf-resolve-hypermedia-links:annotateSources'),
    /**
     * Context entry containing the link filters applied on link queues within the context scope.
     * Setting this entry too high in the context hierarchy could result in too much being filtered out.
     */
    linkFilters: new core_1.ActionContextKey('@comunica/bus-rdf-resolve-hypermedia-links:linkFilters'),
};
exports.KeysExtractLinksTree = {
    /**
     * A flag to indicate if relationships should strictly correspond to the current document's URL.
     * Default true.
     */
    strictTraversal: new core_1.ActionContextKey('@comunica/actor-extract-links-tree:strictTraversal'),
};
exports.KeysRdfJoin = {
    /**
     * If adaptive joining must not be done.
     */
    skipAdaptiveJoin: new core_1.ActionContextKey('@comunica/bus-rdf-join:skipAdaptiveJoin'),
};
//# sourceMappingURL=Keys.js.map